import { KypayRoot } from './components/kypay-root/index.react'

export const KypayApp = () => {
  return <KypayRoot />
}
